import { createSelector } from '@reduxjs/toolkit';

import { initialState } from './slice';

// First select the relevant part from the state
const selectDomain = state => state.packageList || initialState;

export const selectPackages = createSelector(
  [selectDomain],
  state => state.packages,
);

export const selectTotalPackages = createSelector(
  [selectDomain],
  state => state.totalPackages,
);

export const selectLoading = createSelector(
  [selectDomain],
  state => state.loading,
);

export const selectCompaniesLoading = createSelector(
  [selectDomain],
  state => state.isCompaniesLoading,
);

export const selectPackagesLoading = createSelector(
  [selectDomain],
  state => state.isPackagesLoading,
);

export const selectCompanies = createSelector([selectDomain], (state) =>
  [...state.companies]
    .sort((a, b) => a.companyName.localeCompare(b.companyName))
    .map((company) => ({
      label: company.companyName,
      value: company._id,
    }))
);

export const selectCommodities = createSelector([selectDomain], (state) =>
  [...state.commodities]
    .sort((a, b) => a.name.localeCompare(b.name))
);